import { getApi } from "./api_instance";
export const logout = async (logout) => {
  try {
    const { data } = await getApi({
      apiUrl: "/admin/api/user/logout",
      sendToken: true,
      logout,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
